import { FC, useEffect } from 'react';
import { IFaceLoader } from './IFaceLoader';
import { useTranslation } from 'react-i18next';
import { Language } from '@/ui-kit/types';
import { getCurrentFrontend } from '@/ui-kit/utils';
import { Navigate } from 'react-router-dom';
import { getExternalLoginUrl } from '@/ui-kit/utils/getExternalLoginUrl';
import { useLogout } from '@/bo-kit/components/AuthorizedLayout/hooks/useLogout';
import { useUser } from '@/bo-kit/components/AuthorizedLayout/hooks/useUser';
import { LiberSaveFrontend } from '@/bo-kit/types';
import { NavigateToExternalUrl } from '@/bo-kit/components/NavigateToExternalUrl';

export const LogoutPage: FC<{ useExternalLogin?: boolean }> = ({ useExternalLogin }) => {
    const { t } = useTranslation('bo-kit__common');
    const [doLogout, doLogoutInProgress] = useLogout();
    useEffect(() => {
        doLogout();
    }, [doLogout]);
    const user = useUser();
    const { i18n } = useTranslation();
    if (doLogoutInProgress) {
        return <IFaceLoader title={t('Logging out...')} />;
    }
    if (!user) {
        if (useExternalLogin) {
            return (
                <NavigateToExternalUrl
                    to={getExternalLoginUrl(i18n.resolvedLanguage as Language)}
                    delay={150}
                />
            );
        }
        if (getCurrentFrontend() === LiberSaveFrontend.AUTH) {
            return <Navigate to='/' replace />;
        }
        return <Navigate to='/auth' replace />;
    }
    return <IFaceLoader title={t("Now you'll be redirected to login page")} />;
};

// ADHOC: support lazy import
export default LogoutPage;
